import ORDER_ICON_DART from "@assets/svg/order_icon_dart.svg"
import type { StoreCustomer } from "@medusajs/types"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import Image from "next/image"

type Props = {
  customer: StoreCustomer | null
  orderCount: number
}

function OrderButton({ customer, orderCount: orderNumber }: Props) {
  return (
    <LocalizedClientLink
      href={customer ? "/orders" : "/account"}
      data-testid="nav-order-link"
    >
      <div className="flex h-full items-center">
        <div className="relative w-8">
          <Image src={ORDER_ICON_DART} alt="order_icon" />
          <div
            className={`absolute bottom-4 left-4 bg-red-500 text-white font-medium rounded-full flex items-center justify-center shadow-md ${
              true ? "w-4 h-4 text-[10px]" : "w-5 h-5 text-[10px]"
            }`}
          >
            {orderNumber}
          </div>
        </div>
        <div className="lg:flex hidden text-[14px]">Đơn hàng</div>
      </div>
    </LocalizedClientLink>
  )
}

export default OrderButton
